var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","color":"primary","disabled":!_vm.filtersActive},on:{"click":_vm.clearFilters}},[_vm._v("clear filter(s)")])}
var staticRenderFns = []

export { render, staticRenderFns }